//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Toast} from "vant";
export default {
  name: 'companyBindeForm',
  data () {
    return {
      visible: false,
      userInfo: this.$store.getters.getUserInfo,
      confirmLoading: false,
      allCompanys: [],
      appInfo: {}
    }
  },
  methods: {
    showForm (app) {
      this.appInfo = JSON.parse(JSON.stringify(app))
      this.userInfo = this.$store.getters.getUserInfo
      this.allCompanys = []
      this.fnQueryAllUserCompanys()
    },
    fnQueryAllUserCompanys () {
      let param = {
        useAppId: this.appInfo.appCode,
        createUserId: this.userInfo.id
      }
      this.$store.dispatch('company/queryUserHaveCcCompany', JSON.stringify(param))
        .then(res => {
          console.log('fnQueryAllUserCompanys res ===>', res)
          if (res.data && res.data.retCode == 1) {
            this.allCompanys = [...res.data.objs]
          }
          this.visible = true
        }).catch(err => {
          console.log('fnQueryAllUserCompanys err ===>', err)
        })
    },
    confirmBind (companyInfo) {
      let ccCompanyBindSaasBo = {
        ccCompanyBo: companyInfo,
        ucUserBo: this.userInfo,
        bindType: 0
      }
      this.$store.dispatch('company/freeTrySaasSystem', JSON.stringify(ccCompanyBindSaasBo))
        .then(res => {
          console.log('confirmBind res ===>', res)
          if (res.data && res.data.retCode == 1) {
            Toast('绑定成功')
            this.visible = false
          } else {
            Toast(res.data.retMsg)
          }
        }).catch(err => {
          console.log('confirmBind err ===>', err)
        })
    },
    handleBtnCreanteAndBindClicked () {
      this.$emit('createAndBindCompanyInfo', this.appInfo)
      this.visible = false
    },
    handleCancel () {
      this.visible = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/modules/companyBindeForm.vue